export enum FlagsTableHeader {
  Member = 'Member',
  FlagDetails = 'Flag details',
  FlagAuthor = 'Flag author',
  Escalated = 'Escalated',
  Resolved = 'Resolved',
  Status = 'Status',
  Actions = '',
}
